var _path, _circle, _ellipse, _circle2, _line, _line2, _line3, _line4, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _g, _path17, _line17, _line18, _line19, _line20, _line21, _rect, _path18, _g2, _g3, _path19, _ellipse2, _circle7, _rect2, _path20, _rect3, _rect4, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 303,
    viewBox: "0 0 454 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M0 167.613C-6.0574e-05 194.869 22.8556 259.961 72.2953 288.592C122.777 317.825 165.101 293.365 224.632 294.33C269.596 295.058 297.305 307.988 339.788 294.33C399.898 275.004 465.116 241.87 451.329 184.349C441.741 144.347 396.081 144.996 367.673 113.579C339.335 82.2384 342.374 49.8818 307.255 25.1166C231.235 -28.4914 138.522 11.6758 67.6478 71.0215C31.6352 101.176 6.05743e-05 140.357 0 167.613Z",
    fill: "#FAFAFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245.535,
    cy: 87.5047,
    r: 50.9353,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.8922,
    cy: 82.2802,
    rx: 84.8922,
    ry: 82.2802,
    transform: "matrix(-1 0 0 1 218.107 116.237)",
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.146,
    cy: 158.564,
    r: 38.5878,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 157.098,
    y1: 50.9349,
    x2: 157.098,
    y2: 53.9202,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 157.098,
    y1: 59.7045,
    x2: 157.098,
    y2: 62.6897,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    y1: 57.0924,
    x2: 154.486,
    y2: 57.0924,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 159.336,
    y1: 57.0924,
    x2: 162.322,
    y2: 57.0924,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.119,
    cy: 210.924,
    r: 34.6099,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 72,
    r: 5.34698,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.104,
    cy: 37.1042,
    r: 3.45114,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 418.104,
    cy: 184.104,
    r: 3.45114,
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.347 260C143.347 263.552 140.684 266.347 137.5 266.347C134.316 266.347 131.653 263.552 131.653 260C131.653 256.448 134.316 253.653 137.5 253.653C140.684 253.653 143.347 256.448 143.347 260Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.30603
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.501 101.241C330.687 153.362 296.087 194.064 274.389 207.9L274.389 211.578C333.502 169.545 313.094 120.506 295.501 101.241Z",
    fill: "#CAD0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M293.302 98.0881C285.385 93.1842 268.143 81.59 262.513 74.4443C271.163 74.7946 289.431 80.0137 293.302 98.0881Z",
    fill: "#CAD0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.779 117.003C296.087 118.054 284.241 117.108 274.389 104.918C280.171 102.642 293.544 101.871 300.779 117.003Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M306.936 147.477C302.245 145.551 292.422 138.23 290.663 124.359C297.26 124.534 309.751 129.403 306.936 147.477Z",
    fill: "#CAD0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.779 174.799C297.113 172.522 290.223 163.87 291.982 147.477C298.286 149.404 308.872 157.565 300.779 174.799Z",
    fill: "#CAD0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.426 199.493C279.813 194.064 277.995 180.894 283.625 171.646C289.05 174.974 296.204 185.202 281.426 199.493Z",
    fill: "#CAD0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.663 202.646C294.035 197.392 304.649 186.043 320.131 182.68C316.759 191.612 306.145 208.11 290.663 202.646Z",
    fill: "#CAD0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M309.575 174.799C312.068 167.443 319.428 151.996 328.928 149.053C329.938 157.635 327.482 174.799 309.575 174.799Z",
    fill: "#CAD0E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M315.733 145.901C315.293 136.794 316.261 117.739 323.65 114.376C327.755 122.082 331.919 139.176 315.733 145.901Z",
    fill: "#CAD0E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M309.575 114.376C309.575 114.376 299.459 102.291 305.177 82.851C311.335 89.7514 320.835 105.717 309.575 114.376Z",
    fill: "#CAD0E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M261.018 162.134C261.018 162.134 265.631 161.39 267.595 159.425C269.56 157.461 270.304 152.847 270.304 152.847C270.304 152.847 271.048 157.461 273.012 159.425C274.977 161.39 279.59 162.134 279.59 162.134C279.59 162.134 274.977 162.878 273.012 164.842C271.048 166.807 270.304 171.42 270.304 171.42C270.304 171.42 269.56 166.807 267.595 164.842C265.631 162.878 261.018 162.134 261.018 162.134Z",
    fill: "#CAD0E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.405 126.829C347.405 126.829 352.019 126.085 353.983 124.121C355.947 122.156 356.692 117.543 356.692 117.543C356.692 117.543 357.436 122.156 359.4 124.121C361.365 126.085 365.978 126.829 365.978 126.829C365.978 126.829 361.365 127.573 359.4 129.538C357.436 131.502 356.692 136.115 356.692 136.115C356.692 136.115 355.947 131.502 353.983 129.538C352.019 127.573 347.405 126.829 347.405 126.829Z",
    fill: "#CAD0E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M359 152.434C359 152.434 364.68 151.517 367.099 149.099C369.517 146.68 370.434 141 370.434 141C370.434 141 371.35 146.68 373.768 149.099C376.187 151.517 381.867 152.434 381.867 152.434C381.867 152.434 376.187 153.35 373.768 155.768C371.35 158.187 370.434 163.867 370.434 163.867C370.434 163.867 369.517 158.187 367.099 155.768C364.68 153.35 359 152.434 359 152.434Z",
    fill: "#CAD0E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203 271.434C203 271.434 208.68 270.517 211.099 268.099C213.517 265.68 214.434 260 214.434 260C214.434 260 215.35 265.68 217.768 268.099C220.187 270.517 225.867 271.434 225.867 271.434C225.867 271.434 220.187 272.35 217.768 274.768C215.35 277.187 214.434 282.867 214.434 282.867C214.434 282.867 213.517 277.187 211.099 274.768C208.68 272.35 203 271.434 203 271.434Z",
    fill: "#CAD0E1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 61.9408,
    y1: 106.306,
    x2: 61.9408,
    y2: 111.144,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 61.9408,
    y1: 116.24,
    x2: 61.9408,
    y2: 121.077,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 54.4906,
    y1: 113.628,
    x2: 59.3284,
    y2: 113.628,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 64.4232,
    y1: 113.628,
    x2: 69.261,
    y2: 113.628,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 52.7232,
    y1: 121.447,
    x2: 35.808,
    y2: 138.553,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 51.3998,
    y1: 131.401,
    x2: 21.8465,
    y2: 161.153,
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 6.14382,
    y2: -1.30603,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 350.111 201.129)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 6.14382,
    y2: -1.30603,
    transform: "matrix(2.7095e-08 1 1 -3.13413e-08 350.111 211.062)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 5.62079,
    y2: -1.30603,
    transform: "matrix(-1 -1.45705e-08 -1.45705e-08 1 357.038 211.062)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 5.62079,
    y2: -1.30603,
    transform: "matrix(-1 -1.56706e-08 -1.35475e-08 1 347.803 211.062)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 24.4543,
    y2: -1.30603,
    transform: "matrix(0.676828 0.736141 0.685017 -0.728527 356.744 217.255)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1.30603,
    y1: -1.30603,
    x2: 41.7167,
    y2: -1.30603,
    transform: "matrix(0.678477 0.734622 0.68338 -0.730063 358.703 225.683)",
    stroke: "#CAD0E1",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_69_256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.4434,
    y: 161.312,
    width: 125.379,
    height: 79.1869,
    rx: 8,
    transform: "rotate(-8.69553 74.4434 161.312)",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2332 166.477C74.797 163.625 76.7554 160.959 79.6074 160.523L193.217 143.147C196.069 142.711 198.735 144.669 199.171 147.521L201.125 160.296L77.1869 179.251L75.2332 166.477Z",
    fill: "#D9DDE9"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 148.247,
    y1: 205.342,
    x2: 193.297,
    y2: 198.452,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 146.335,
    y1: 192.841,
    x2: 191.385,
    y2: 185.951,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 144.423,
    y1: 180.338,
    x2: 189.472,
    y2: 173.448,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 150.159,
    y1: 217.845,
    x2: 187.055,
    y2: 212.202,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 84.3523,
    y1: 169.498,
    x2: 116.356,
    y2: 164.603,
    stroke: "white",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.999,
    y: 186.733,
    width: 44.5426,
    height: 44.5426,
    rx: 3,
    transform: "rotate(-8.69553 85.999 186.733)",
    fill: "#D9DDE9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.878 215.701C118.125 214.674 116.469 213.447 115.995 210.35C115.711 208.491 116.998 207.062 117.256 205.392C117.513 203.722 117.515 201.792 117.546 200.383C117.578 198.974 117.592 198.429 117.5 196.947C117.381 195.098 115.495 190.566 109.262 191.52C103.03 192.473 102.581 197.362 103.024 199.161C103.379 200.603 103.556 201.119 104.007 202.454C104.457 203.789 105.033 205.631 105.778 207.147C106.522 208.664 108.18 209.643 108.464 211.502C108.938 214.599 107.724 216.265 103.496 218.665C99.2519 221.072 96.5854 223.213 96.7684 224.41L97.6257 230.016L131.872 224.778L131.014 219.172C130.832 217.977 127.645 216.732 122.878 215.701Z",
    fill: "#B3BAD3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_69_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.659 169.433C264.629 177.97 256.875 184.057 248.338 183.028L147.268 170.849C138.731 169.821 132.644 162.067 133.673 153.53L139.976 101.211C141.006 92.6741 148.76 86.5876 157.297 87.6174L258.367 99.7948C266.904 100.822 272.991 108.577 271.962 117.115L265.659 169.433Z",
    fill: "#E2E6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.635 155.679L174.344 146.366L174.489 145.177L251.777 154.489L251.635 155.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.774 162.814L173.484 153.501L173.628 152.313L250.918 161.625L250.774 162.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.724 156.838L175.327 158.041C175.485 158.353 175.614 158.64 175.751 158.949L175.782 158.952C175.992 158.663 176.193 158.416 176.4 158.159L177.26 157.144L178.278 157.268L176.209 159.558L177.706 162.454L176.635 162.326L176.016 161.068C175.849 160.742 175.712 160.434 175.568 160.1L175.545 160.098C175.337 160.387 175.122 160.645 174.892 160.931L174.002 162.008L172.965 161.884L175.123 159.46L173.674 156.711L174.724 156.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.678 157.436L180.283 158.638C180.441 158.951 180.568 159.237 180.705 159.546L180.736 159.55C180.946 159.26 181.148 159.012 181.354 158.757L182.214 157.741L183.232 157.864L181.163 160.156L182.662 163.052L181.591 162.922L180.97 161.664C180.805 161.339 180.666 161.031 180.524 160.697L180.501 160.695C180.293 160.985 180.076 161.242 179.847 161.527L178.957 162.605L177.919 162.48L180.077 160.058L178.629 157.309L179.678 157.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.632 158.032L185.237 159.236C185.395 159.547 185.524 159.835 185.661 160.142L185.692 160.148C185.902 159.857 186.104 159.608 186.31 159.354L187.17 158.339L188.187 158.461L186.119 160.752L187.616 163.649L186.545 163.52L185.926 162.262C185.759 161.936 185.622 161.628 185.478 161.294L185.455 161.293C185.247 161.581 185.032 161.839 184.802 162.125L183.912 163.202L182.875 163.076L185.033 160.654L183.584 157.905L184.632 158.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.588 158.63L190.191 159.832C190.351 160.145 190.478 160.431 190.615 160.739L190.646 160.744C190.856 160.456 191.059 160.207 191.264 159.951L192.124 158.935L193.143 159.058L191.074 161.35L192.572 164.247L191.501 164.117L190.88 162.858C190.713 162.534 190.578 162.224 190.432 161.892L190.411 161.889C190.203 162.179 189.987 162.436 189.756 162.722L188.868 163.799L187.829 163.674L189.987 161.252L188.539 158.503L189.588 158.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.542 159.226L195.147 160.428C195.305 160.74 195.432 161.027 195.569 161.337L195.6 161.341C195.81 161.051 196.014 160.803 196.218 160.548L197.08 159.532L198.097 159.653L196.028 161.946L197.526 164.843L196.456 164.714L195.836 163.455C195.669 163.13 195.533 162.822 195.388 162.489L195.365 162.486C195.158 162.774 194.941 163.031 194.712 163.319L193.822 164.395L192.783 164.269L194.943 161.849L193.494 159.099L194.542 159.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.497 159.824L200.101 161.026C200.258 161.338 200.388 161.625 200.525 161.935L200.556 161.938C200.766 161.649 200.967 161.401 201.174 161.144L202.034 160.129L203.051 160.252L200.982 162.542L202.479 165.439L201.409 165.311L200.79 164.052C200.623 163.728 200.487 163.418 200.342 163.086L200.32 163.083C200.111 163.373 199.896 163.629 199.666 163.916L198.776 164.993L197.739 164.867L199.897 162.447L198.448 159.697L199.497 159.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9 162.563L205.815 163.256L203.171 162.939L203.255 162.242L205.9 162.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.674 160.809L208.279 162.011C208.437 162.323 208.564 162.61 208.701 162.92L208.732 162.922C208.942 162.634 209.146 162.386 209.35 162.131L210.21 161.114L211.228 161.236L209.16 163.529L210.658 166.426L209.587 166.296L208.966 165.036C208.801 164.713 208.664 164.403 208.518 164.071L208.497 164.068C208.289 164.357 208.073 164.614 207.842 164.901L206.953 165.978L205.915 165.852L208.075 163.432L206.624 160.682L207.674 160.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.627 161.406L213.232 162.608C213.391 162.921 213.519 163.207 213.656 163.517L213.686 163.52C213.896 163.23 214.1 162.983 214.304 162.727L215.165 161.711L216.182 161.834L214.114 164.124L215.612 167.021L214.542 166.893L213.921 165.634C213.754 165.31 213.619 165 213.473 164.668L213.452 164.665C213.244 164.955 213.027 165.211 212.797 165.498L211.907 166.575L210.87 166.449L213.028 164.029L211.58 161.279L212.627 161.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.583 162.002L218.186 163.204C218.345 163.517 218.473 163.803 218.61 164.113L218.641 164.116C218.851 163.828 219.054 163.579 219.259 163.324L220.121 162.307L221.138 162.431L219.069 164.722L220.566 167.619L219.496 167.489L218.875 166.231C218.708 165.906 218.573 165.596 218.427 165.264L218.406 165.261C218.198 165.552 217.982 165.808 217.751 166.094L216.861 167.171L215.824 167.047L217.984 164.625L216.533 161.876L217.583 162.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.538 162.599L223.143 163.802C223.301 164.115 223.428 164.402 223.565 164.711L223.596 164.714C223.806 164.424 224.009 164.178 224.214 163.921L225.074 162.905L226.093 163.029L224.023 165.32L225.521 168.216L224.451 168.087L223.832 166.829C223.665 166.504 223.527 166.195 223.383 165.862L223.361 165.859C223.153 166.149 222.936 166.407 222.706 166.692L221.818 167.769L220.779 167.645L222.937 165.222L221.49 162.473L222.538 162.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.491 163.198L228.096 164.4C228.254 164.712 228.383 164.999 228.52 165.307L228.551 165.312C228.759 165.022 228.962 164.774 229.169 164.519L230.029 163.503L231.046 163.626L228.978 165.918L230.475 168.813L229.404 168.684L228.785 167.426C228.618 167.1 228.481 166.792 228.337 166.458L228.314 166.457C228.106 166.747 227.891 167.003 227.661 167.289L226.771 168.367L225.732 168.241L227.892 165.819L226.443 163.071L227.491 163.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.662 122.509C261.068 127.434 256.596 130.946 251.669 130.351L201.728 124.335C196.804 123.741 193.292 119.268 193.886 114.343C194.479 109.416 198.952 105.905 203.879 106.499L253.818 112.517C258.744 113.11 262.257 117.583 261.662 122.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.941 129.419L239.186 128.847L241.334 111.009L246.091 111.583L243.941 129.419Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.618 128.418L228.484 127.558L230.633 109.723L237.766 110.582L235.618 128.418Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_69_256)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.182,
    cy: 153.311,
    r: 49.6486,
    fill: "#B5D8D4",
    fillOpacity: 0.75,
    stroke: "#4EA699",
    strokeWidth: 9.14224
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.823,
    y: 209.186,
    width: 23.3889,
    height: 69.1035,
    rx: 11.6944,
    transform: "rotate(-45 265.823 209.186)",
    fill: "#4EA699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 237.5L301.708 245.113C310.759 254.052 325.812 245.282 322.5 233L322.788 233.281C327.43 237.81 327.477 245.259 322.891 249.845C318.355 254.381 311.005 254.393 306.455 249.873L294 237.5Z",
    fill: "#4B978C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.26922,
    height: 15.7867,
    rx: 4.13461,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 274.859 207.531)",
    fill: "#4EA699"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.059,
    y1: 206.468,
    x2: 308.348,
    y2: 223.757,
    stroke: "white",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.322,
    y1: 227.73,
    x2: 317.917,
    y2: 233.325,
    stroke: "white",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.781 119.084C264.334 122.29 269.012 126.817 272.398 132.262C275.784 137.708 277.776 143.905 278.195 150.304C278.614 156.703 277.449 163.107 274.803 168.948C272.156 174.79 268.11 179.888 263.022 183.792C257.934 187.696 251.962 190.285 245.635 191.329C239.308 192.374 232.821 191.842 226.748 189.781C220.676 187.719 215.205 184.192 210.821 179.512C206.438 174.831 203.276 169.142 201.616 162.948C202.93 167.852 209.219 172.57 212.69 176.276C216.911 178.713 221.781 180.792 226.589 182.424C231.397 184.056 239.303 184.144 244.312 183.317C249.322 182.489 254.05 180.44 258.078 177.349C262.106 174.258 265.902 170.04 267.997 165.415C270.092 160.79 271.52 152.067 271.188 147C270.856 141.934 270.678 135.596 267.997 131.284C265.316 126.972 263.178 121.622 258.781 119.084Z",
    fill: "white",
    fillOpacity: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.933,
    cy: 124.437,
    rx: 15.7066,
    ry: 10.8321,
    transform: "rotate(-2.6891 235.933 124.437)",
    fill: "white",
    fillOpacity: 0.7
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.173,
    cy: 131.314,
    r: 4.16212,
    transform: "rotate(-2.6891 212.173 131.314)",
    fill: "white",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145.599,
    y: 103.017,
    width: 19.5715,
    height: 19.5715,
    rx: 2,
    transform: "rotate(4.64321 145.599 103.017)",
    fill: "#FFC73D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5 113.502L165 106.502L163.671 122.453C163.577 123.575 162.576 124.399 161.457 124.275L150 123.002L158.5 113.502Z",
    fill: "#FFEFC7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 145.302,
    y: 106.674,
    width: 19.5715,
    height: 1.22322,
    transform: "rotate(4.64321 145.302 106.674)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.005,
    y: 110.331,
    width: 19.5715,
    height: 1.22322,
    transform: "rotate(4.64321 145.005 110.331)",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.317 112.64C158.098 115.333 156.284 117.384 154.263 117.22C152.243 117.056 150.783 114.739 151.002 112.046C153.745 112.269 152.64 112.179 154.66 112.343C156.68 112.507 156.031 112.454 158.317 112.64Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.197 111.322C156.978 114.015 155.709 116.11 154.363 116.001C153.016 115.891 152.102 113.619 152.32 110.926C154.149 111.074 153.412 111.014 154.759 111.124C156.105 111.233 155.673 111.198 157.197 111.322Z",
    fill: "#FFC73D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_69_256",
    x: 70.3354,
    y: 140.862,
    width: 144.126,
    height: 105.447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_69_256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_69_256",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_69_256",
    x: 128.335,
    y: 87.5039,
    width: 148.964,
    height: 106.086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_69_256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_69_256",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_69_256",
    x: 178.738,
    y: 99.0918,
    width: 152.868,
    height: 164.611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.815686 0 0 0 0 0.882353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_69_256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_69_256",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCheck);
export default __webpack_public_path__ + "static/media/credit-check.d9b01a55e84572fad1164a3610506920.svg";
export { ForwardRef as ReactComponent };